import React from 'react';
import * as T from '../template.tsx';
import '../main.css';

function Collection() {
  return (
    <>
        <T.NavBar/>
        <div className="bg-slate-300 w-screen flex">
            <div className=" w-full h-full text-center align-middle pt-10">
            collection
            </div>
        </div>
    </>
    
  );
}

export default Collection;
